(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0426"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0426"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $33fadf0fc7258ac8$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("bu0dN"), JSON.parse('["bu0dN","index.c9be3e50.js","hBteH","dice-1.8a72e595.png","5xboM","dice-2.ddc1b739.png","5kIy6","dice-3.433d125d.png","iOW4l","dice-4.37e5f716.png","flXE5","dice-5.b7ae9b64.png","hBzXi","dice-6.9e5fc14a.png"]'));

// Selecting Elements
var $8cb9403b4f2235a9$exports = {};

$8cb9403b4f2235a9$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "dice-1.8a72e595.png";


var $0467f1c30a319bf8$exports = {};

$0467f1c30a319bf8$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "dice-2.ddc1b739.png";


var $5001e35f5ddcf651$exports = {};

$5001e35f5ddcf651$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "dice-3.433d125d.png";


var $78cc5a453d8e60f5$exports = {};

$78cc5a453d8e60f5$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "dice-4.37e5f716.png";


var $d6ca38e13120deb4$exports = {};

$d6ca38e13120deb4$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "dice-5.b7ae9b64.png";


var $898487e434cbab81$exports = {};

$898487e434cbab81$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "dice-6.9e5fc14a.png";


const $66b821ea461d9f2a$var$player0El = document.querySelector(".player--0");
const $66b821ea461d9f2a$var$player1El = document.querySelector(".player--1");
const $66b821ea461d9f2a$var$score0El = document.querySelector("#score--0");
const $66b821ea461d9f2a$var$score1El = document.getElementById("score--1");
const $66b821ea461d9f2a$var$current0El = document.getElementById("current--0");
const $66b821ea461d9f2a$var$current1El = document.getElementById("current--1");
const $66b821ea461d9f2a$var$diceEl = document.querySelector(".dice");
const $66b821ea461d9f2a$var$btnNew = document.querySelector(".btn--new");
const $66b821ea461d9f2a$var$btnRoll = document.querySelector(".btn--roll");
const $66b821ea461d9f2a$var$btnHold = document.querySelector(".btn--hold");
// Starting Conditions
let $66b821ea461d9f2a$var$scores, $66b821ea461d9f2a$var$currentScore, $66b821ea461d9f2a$var$activePlayer, $66b821ea461d9f2a$var$playing;
const $66b821ea461d9f2a$var$init = function() {
    $66b821ea461d9f2a$var$scores = [
        0,
        0
    ];
    $66b821ea461d9f2a$var$currentScore = 0;
    $66b821ea461d9f2a$var$activePlayer = 0;
    $66b821ea461d9f2a$var$playing = true;
    $66b821ea461d9f2a$var$score0El.textContent = 0;
    $66b821ea461d9f2a$var$score1El.textContent = 0;
    $66b821ea461d9f2a$var$current0El.textContent = 0;
    $66b821ea461d9f2a$var$current1El.textContent = 0;
    $66b821ea461d9f2a$var$diceEl.classList.add("hidden");
    $66b821ea461d9f2a$var$player0El.classList.remove("player--winner");
    $66b821ea461d9f2a$var$player1El.classList.remove("player--winner");
    $66b821ea461d9f2a$var$player1El.classList.remove("player--active");
    $66b821ea461d9f2a$var$player0El.classList.add("player--active");
};
$66b821ea461d9f2a$var$init();
const $66b821ea461d9f2a$var$switchPlayer = function() {
    $66b821ea461d9f2a$var$currentScore = 0;
    document.getElementById(`current--${$66b821ea461d9f2a$var$activePlayer}`).textContent = 0;
    $66b821ea461d9f2a$var$activePlayer = $66b821ea461d9f2a$var$activePlayer === 0 ? 1 : 0;
    $66b821ea461d9f2a$var$player0El.classList.toggle("player--active");
    $66b821ea461d9f2a$var$player1El.classList.toggle("player--active");
};
// Rolling Dice Functionality
$66b821ea461d9f2a$var$btnRoll.addEventListener("click", function() {
    if ($66b821ea461d9f2a$var$playing) {
        // 1 Generate random dice roll
        const dice = Math.trunc(Math.random() * 6) + 1;
        // 2 Display Roll
        $66b821ea461d9f2a$var$diceEl.classList.remove("hidden");
        let diceSrc;
        switch(dice){
            case 1:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($8cb9403b4f2235a9$exports)));
                break;
            case 2:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($0467f1c30a319bf8$exports)));
                break;
            case 3:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($5001e35f5ddcf651$exports)));
                break;
            case 4:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($78cc5a453d8e60f5$exports)));
                break;
            case 5:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($d6ca38e13120deb4$exports)));
                break;
            case 6:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($898487e434cbab81$exports)));
                break;
            default:
                diceSrc = ""; // Handle default case
        }
        $66b821ea461d9f2a$var$diceEl.src = diceSrc;
        // 3 Check for a roll of 1
        if (dice !== 1) {
            // Not a 1, add to score
            $66b821ea461d9f2a$var$currentScore += dice;
            document.getElementById(`current--${$66b821ea461d9f2a$var$activePlayer}`).textContent = $66b821ea461d9f2a$var$currentScore;
        } else // if true switch to next player
        $66b821ea461d9f2a$var$switchPlayer();
    }
});
$66b821ea461d9f2a$var$btnHold.addEventListener("click", function() {
    if ($66b821ea461d9f2a$var$playing) {
        // 1 Add current score to active player's score
        $66b821ea461d9f2a$var$scores[$66b821ea461d9f2a$var$activePlayer] += $66b821ea461d9f2a$var$currentScore;
        document.getElementById(`score--${$66b821ea461d9f2a$var$activePlayer}`).textContent = $66b821ea461d9f2a$var$scores[$66b821ea461d9f2a$var$activePlayer];
        // 2 Check if player's score is >= 100
        if ($66b821ea461d9f2a$var$scores[$66b821ea461d9f2a$var$activePlayer] >= 100) {
            // 3 Finish the game
            $66b821ea461d9f2a$var$playing = false;
            $66b821ea461d9f2a$var$diceEl.classList.add("hidden");
            document.querySelector(`.player--${$66b821ea461d9f2a$var$activePlayer}`).classList.add("player--winner");
            document.querySelector(`.player--${$66b821ea461d9f2a$var$activePlayer}`).classList.remove("player--active");
        } else // 4 Switch to next player
        $66b821ea461d9f2a$var$switchPlayer();
    }
});
// Reset
$66b821ea461d9f2a$var$btnNew.addEventListener("click", $66b821ea461d9f2a$var$init);

})();
//# sourceMappingURL=index.c9be3e50.js.map
